<div class="row border-bottom pb-2 arabic-dir">
  <h5 class="text-primary text-left col-10">
    {{ "BAZZAR.CHANGE_PASSWORD" | translate }}
  </h5>
  <i
    class="fa fa-times text-dark text-right text-left-ar col-2 pt-1"
    (click)="onNoClick()"
  ></i>
</div>
<div>
  <form action="" class="mt-4" [formGroup]="changePasswordForm">
    <div class="form-group">
      <div class="row mx-0">
        <div class="my-auto col-md-3 px-0 text-left">
          <label class="small font-weight-bold text-left">
            {{ "BAZZAR.CURRENT_PASSWORD" | translate }}
          </label>
        </div>
        <div class="col-md-8 px-0">
          <input
            type="password"
            formControlName="currentPassword"
            value=""
            required
            maxlength="100"
            minlength="6"
            class="form-control form-control-sm"
          />
          <mat-error
            *ngIf="
              changePasswordForm.controls.currentPassword.errors?.required &&
              changePasswordForm.controls.currentPassword.touched
            "
            >{{ "BAZZAR.REQUIRED" | translate }}</mat-error
          >

          <mat-error
            *ngIf="
              changePasswordForm.controls.currentPassword.hasError('minlength')
            "
          >
            {{ "BAZZAR.PASSWORD_LENGTH" | translate }}
          </mat-error>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row mx-0">
        <div class="my-auto col-md-3 px-0 text-left">
          <label class="small font-weight-bold text-left">
            {{ "BAZZAR.NEW_PASSWORD" | translate }}
          </label>
        </div>
        <div class="col-md-8 px-0">
          <input
            type="password"
            formControlName="newPassword"
            required
            minlength="6"
            maxlength="100"
            class="form-control form-control-sm"
          />
          <mat-error
            *ngIf="
              changePasswordForm.controls.newPassword.errors?.required &&
              changePasswordForm.controls.newPassword.touched
            "
            >{{ "BAZZAR.REQUIRED" | translate }}</mat-error
          >

          <mat-error
            *ngIf="
              changePasswordForm.controls.newPassword.hasError('minlength')
            "
          >
            {{ "BAZZAR.PASSWORD_LENGTH" | translate }}
          </mat-error>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row mx-0">
        <div class="my-auto col-md-3 text-left px-0">
          <label class="small font-weight-bold text-left">
            {{ "BAZZAR.RETYPE_PASSWORD" | translate }}
          </label>
        </div>
        <div class="col-md-8 px-0">
          <input
            type="password"
            formControlName="retypePassword"
            value=""
            required
            minlength="6"
            maxlength="50"
            class="form-control form-control-sm"
          />
          <mat-error
            *ngIf="
              changePasswordForm.controls.retypePassword.errors?.required &&
              changePasswordForm.controls.retypePassword.touched
            "
            >{{ "BAZZAR.REQUIRED" | translate }}</mat-error
          >

          <mat-error
            *ngIf="
              changePasswordForm.controls.retypePassword.hasError('minlength')
            "
          >
            {{ "BAZZAR.PASSWORD_LENGTH" | translate }}
          </mat-error>
        </div>
      </div>
    </div>
  </form>
  <div class="text-right mt-4 text-left-ar">
    <button class="btn btn-outline-success mx-1" (click)="onNoClick()">
      {{ "BAZZAR.CANCEL" | translate }}
    </button>
    <button class="btn btn-success mx-1">
      {{ "BAZZAR.CONFIRM" | translate }}
    </button>
  </div>
</div>
